<template>
  <Transition
    enter-active-class="transition-opacity duration-300 ease-in-out"
    leave-active-class="transition-opacity duration-300 ease-in-out"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="props.visible"
      class="fixed inset-0 z-50 flex items-center justify-center"
      :class="[
        props.size === 'full'
          ? 'bg-white bg-opacity-90'
          : 'pointer-events-none',
      ]"
    >
      <div
        :class="[
          props.size === 'full'
            ? 'text-center'
            : 'text-center bg-black bg-opacity-80 rounded-xl w-[150px] h-[120px] flex flex-col items-center justify-center pointer-events-auto',
        ]"
      >
        <div
          class="animate-spin h-12 w-12 border-4 border-teal-400 border-t-transparent rounded-full mx-auto mb-4"
        ></div>
        <p
          v-if="props.size === 'full'"
          class="text-gray-700 text-lg font-medium"
        >
          {{ props.message }}
        </p>
        <p v-else class="text-white text-lg font-medium">
          {{ props.message }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { LoadingSize } from './useLoading'

const props = withDefaults(
  defineProps<{
    visible: boolean
    size?: LoadingSize
    message?: string
  }>(),
  { size: 'full', message: 'Loading...' },
)
</script>
